import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import ImageMob1x from './unified-api-mob1x.png'
import ImageMob2x from './unified-api-mob2x.png'
import ImageDesk1x from './unified-api-desk1x.png'
import ImageDesk2x from './unified-api-desk2x.png'
import classes from './DifferenceUnifiedAPI.module.scss'

export const DifferenceUnifiedAPI = () => {
  return (
    <Block
      as={'section'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <hgroup className={classes.heading}>
        <Heading
          as={'h3'}
          size={'sm'}
          center
          balance
          className={classes.subject}
        >
          Universal Integration Layer vs Unified APls
        </Heading>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Unified API Builder is better than Unified API
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Unified APls have a static set of endpoints you can use. We went
          further and offer you a Unified API Builder. You can custom-build
          endpoints (functions), flows, field mappings, and many other building
          blocks for your integrations, or working consistently across multiple
          external apps.
        </Text>
      </hgroup>

      <div className={classes.visual}>
        <picture className={classes.image}>
          <source
            media='(min-resolution: 2dppx) and (min-width: 768px)'
            srcSet={ImageDesk2x.src}
          />
          <source media='(min-width: 768px)' srcSet={ImageDesk1x.src} />
          <source
            media='(min-resolution: 2dppx) and (max-width: 767px)'
            srcSet={ImageMob2x.src}
          />
          <source media='(max-width: 767px)' srcSet={ImageMob1x.src} />
          <img src={ImageMob1x.src} alt='Unified API Builder' loading='lazy' />
        </picture>
      </div>
    </Block>
  )
}
